export default __webpack_public_path__ + "static/media/contract.f455c5e7.svg";